import { LoadableRoute } from 'routes/utils/loadable';

export const Loading = LoadableRoute({
  loader: () => import(/* webpackChunkName: "LoadingComponent" */ './Loading'),
});
